import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "256",
  height: "256",
  fill: "currentColor",
  viewBox: "0 0 200 200"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M22 130q38-60 78-30 30 22 58 0 4-4 12 2 8 8 4 38-44 28-94 20-40-4-58-20Z" }, null, -1),
    _createElementVNode("path", {
      fill: "none",
      stroke: "var(--mc-avatar)",
      "stroke-linecap": "round",
      "stroke-width": "4",
      d: "M80 116q20-6 40 6"
    }, null, -1),
    _createElementVNode("path", {
      fill: "none",
      stroke: "var(--mc-avatar)",
      "stroke-linecap": "round",
      "stroke-width": "3",
      d: "M50 142q30-2 60 6"
    }, null, -1)
  ]))]))
}
export default { render: render }